
export default {
    name: 'OrderFeedbackSummaryRow',

    props: {
        feedback: {
            type: Array,
            default: () => [],
        },
        isCompact: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        statusVariant() {
            return {
                submitted: 'infogrey',
                in_progress: 'warning',
                resolved: 'success',
                declined: 'danger',
            }
        },
    },
}
